import React from "react";
import { Clock, CheckCircle2, XCircle, Inbox } from "lucide-react";
import Skeleton from "components/ui/Skeleton";

const TILES = [
  {
    key: "PENDING",
    label: "Pending Review",
    icon: Clock,
    iconWrap: "bg-warning_bg text-warning border-warning_border",
    accent: "bg-warning",
  },
  {
    key: "APPROVED",
    label: "Approved",
    icon: CheckCircle2,
    iconWrap: "bg-success_bg text-success border-success_border",
    accent: "bg-success",
  },
  {
    key: "REJECTED",
    label: "Rejected",
    icon: XCircle,
    iconWrap: "bg-danger_bg text-danger border-danger_border",
    accent: "bg-danger",
  },
  {
    key: "ALL",
    label: "Total Requests",
    icon: Inbox,
    iconWrap: "bg-info_bg text-info border-info_border",
    accent: "bg-info",
  },
];

const ApprovalStats = ({ stats, loading, activeFilter, onSelect }) => {
  if (loading) {
    return <Skeleton.Tiles count={4} className="grid-cols-2 sm:grid-cols-4" />;
  }

  return (
    <div className="space-y-2">
      <div className="text-xs font-medium text-text_muted">Filter by status</div>

      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {TILES.map((tile) => {
          const Icon = tile.icon;
          const count = stats?.[tile.key] ?? 0;
          const isActive = activeFilter === tile.key;

          return (
            <button
              key={tile.key}
              type="button"
              aria-pressed={isActive}
              onClick={() => onSelect?.(tile.key)}
              className={`relative flex items-center gap-3.5 overflow-hidden rounded-xl border p-4 text-left cursor-pointer ${
                isActive
                  ? "border-primary bg-primary_tint ring-1 ring-primary"
                  : "border-border bg-surface"
              }`}
            >
              <span className={`absolute inset-y-0 left-0 w-1 ${tile.accent} ${isActive ? "opacity-100" : "opacity-0"}`} />

              <div className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border ${tile.iconWrap}`}>
                <Icon size={19} />
              </div>
              <div className="min-w-0">
                <div className="text-xl font-semibold leading-tight text-text_primary tabular-nums">
                  {count}
                </div>
                <div className={`truncate text-xs font-medium ${isActive ? "text-primary" : "text-text_secondary"}`}>
                  {tile.label}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ApprovalStats;
